/* Black November CPE 2026 · comportamento da landing
   - % 3D, parallax, esfera de pontos, partículas, contagem, revelar ao rolar
   - formulário (validação, máscara, UTMs, envio à CloudPage do Marketing Cloud)
   - modo "preview": simula o envio e mostra o obrigado sem postar nada */
(function () {
  'use strict';
  var root = document.querySelector('.bn');
  if (!root) return;
  root.classList.add('js-on');

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var MOBILE = mq('(max-width: 767px)');
  var FINE = mq('(pointer: fine)');
  var raf = window.requestAnimationFrame.bind(window);
  var hasIO = 'IntersectionObserver' in window;

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function pub(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  /* ---------- % 3D: camadas de extrusão ---------- */
  function rgb(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  function mix(a, b, t) { var A = rgb(a), B = rgb(b); return 'rgb(' + A.map(function (v, i) { return Math.round(v + (B[i] - v) * t); }).join(',') + ')'; }
  root.querySelectorAll('.bn-pct-s').forEach(function (s) {
    var n = RM ? 1 : (MOBILE ? 12 : 26);
    for (var i = 0; i < n; i++) {
      var sp = document.createElement('span');
      sp.textContent = '%';
      sp.style.setProperty('--i', i);
      if (i > 0) sp.style.setProperty('--c', mix('#e9b000', '#4a3600', i / (n - 1)));
      s.appendChild(sp);
    }
  });

  /* ---------- parallax dos % (mouse no desktop, rolagem em todos) ---------- */
  var pcts = [].slice.call(root.querySelectorAll('.bn-pct[data-depth]'));
  var mx = 0, my = 0, ticking = false;
  function applyPar() {
    ticking = false;
    var vh = window.innerHeight;
    pcts.forEach(function (p) {
      var d = parseFloat(p.getAttribute('data-depth')) || 0.5;
      var box = p.parentElement.getBoundingClientRect();
      if (box.bottom < -200 || box.top > vh + 200) return;
      var rel = box.top + box.height / 2 - vh / 2;
      p.style.setProperty('--px', (mx * d * 34).toFixed(1) + 'px');
      p.style.setProperty('--py', (my * d * 34 - rel * d * 0.09).toFixed(1) + 'px');
    });
  }
  function reqPar() { if (!ticking) { ticking = true; raf(applyPar); } }
  if (!RM && pcts.length) {
    if (FINE) window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; reqPar(); }, { passive: true });
    window.addEventListener('scroll', reqPar, { passive: true });
    reqPar();
  }

  /* ---------- canvas utilitários ---------- */
  function fit(c) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = c.clientWidth, h = c.clientHeight;
    c.width = Math.max(1, Math.round(w * dpr)); c.height = Math.max(1, Math.round(h * dpr));
    var ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { ctx: ctx, w: w, h: h };
  }
  function loopWhenVisible(el, draw) {
    var on = false, id = 0, inView = false;
    function tick(t) { draw(t); id = raf(tick); }
    function sync() {
      var should = inView && !document.hidden;
      if (should && !on) { on = true; id = raf(tick); }
      else if (!should && on) { on = false; cancelAnimationFrame(id); }
    }
    if (hasIO) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }).observe(el);
    else { inView = true; sync(); }
    document.addEventListener('visibilitychange', sync);
  }

  /* ---------- esfera de pontos (símbolo da CPE) ---------- */
  var sph = root.querySelector('[data-bn-sphere]');
  if (sph) {
    var S = fit(sph), N = MOBILE ? 340 : 640, pts = [], ga = Math.PI * (3 - Math.sqrt(5));
    for (var i = 0; i < N; i++) { var y = 1 - (i / (N - 1)) * 2, r = Math.sqrt(1 - y * y), th = ga * i; pts.push([Math.cos(th) * r, y, Math.sin(th) * r]); }
    var ang = 0.6, tilt = -0.4, ct = Math.cos(tilt), st = Math.sin(tilt);
    var drawS = function () {
      var c = S.ctx, w = S.w, h = S.h, R = Math.min(w, h) * 0.42, cx = w / 2, cy = h / 2;
      c.clearRect(0, 0, w, h);
      if (!RM) ang += 0.0034;
      var ca = Math.cos(ang), sa = Math.sin(ang);
      for (var k = 0; k < N; k++) {
        var p = pts[k], x = p[0] * ca + p[2] * sa, z = -p[0] * sa + p[2] * ca;
        var yy = p[1] * ct - z * st; z = p[1] * st + z * ct;
        var dep = (z + 1) / 2;
        c.fillStyle = 'rgba(' + (251 + 3 * dep | 0) + ',' + (184 + 30 * dep | 0) + ',0,' + (0.07 + dep * 0.86).toFixed(3) + ')';
        c.beginPath(); c.arc(cx + x * R, cy + yy * R, 0.6 + dep * dep * 3.4, 0, 6.2832); c.fill();
      }
    };
    if (RM) drawS(); else loopWhenVisible(sph, drawS);
    window.addEventListener('resize', debounce(function () { S = fit(sph); drawS(); }, 200));
  }

  /* ---------- partículas subindo no hero ---------- */
  var pc = root.querySelector('[data-bn-particles]');
  if (pc && !RM) {
    var P = fit(pc), M = MOBILE ? 26 : 60, parts = [];
    var spawn = function (init) { return { x: Math.random() * P.w, y: init ? Math.random() * P.h : P.h + 10, r: 0.5 + Math.random() * 1.7, vy: 0.15 + Math.random() * 0.5, ph: Math.random() * 6.28, a: 0.15 + Math.random() * 0.6 }; };
    for (var j = 0; j < M; j++) parts.push(spawn(true));
    loopWhenVisible(pc, function (t) {
      var c = P.ctx; c.clearRect(0, 0, P.w, P.h);
      for (var q = 0; q < parts.length; q++) {
        var o = parts[q]; o.y -= o.vy; o.x += Math.sin(t / 1400 + o.ph) * 0.25;
        if (o.y < -10) { parts[q] = o = spawn(false); }
        c.fillStyle = 'rgba(254,214,0,' + (o.a * (0.6 + 0.4 * Math.sin(t / 500 + o.ph))).toFixed(3) + ')';
        c.beginPath(); c.arc(o.x, o.y, o.r, 0, 6.2832); c.fill();
      }
    });
    window.addEventListener('resize', debounce(function () { P = fit(pc); }, 200));
  }

  /* ---------- revelar ao rolar ---------- */
  var rv = [].slice.call(root.querySelectorAll('.bn-rv'));
  if (hasIO && !RM) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var el = e.target; el.classList.add('is-in'); io.unobserve(el); setTimeout(function () { el.classList.add('is-done'); }, 1300); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- inclinação 3D dos cards ---------- */
  if (!RM && FINE) {
    root.querySelectorAll('.bn-tilt').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var b = el.getBoundingClientRect(), x = (e.clientX - b.left) / b.width, y = (e.clientY - b.top) / b.height;
        el.style.transform = 'perspective(800px) rotateX(' + ((0.5 - y) * 9).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 11).toFixed(2) + 'deg) translateY(-4px)';
        el.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- contador animado ---------- */
  root.querySelectorAll('[data-count]').forEach(function (el) {
    var to = parseInt(el.getAttribute('data-count'), 10);
    if (RM || !hasIO) { el.textContent = to; return; }
    el.textContent = '0';
    var o = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; o.disconnect();
      var t0 = performance.now();
      (function step(t) { var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(to * e); if (k < 1) raf(step); })(t0);
    }, { threshold: 0.6 });
    o.observe(el);
  });

  /* ---------- "??" embaralhando (sem números falsos) ---------- */
  var GLY = ['?#', '#?', '!?', '?!', '##', '%?', '?%', '??'];
  root.querySelectorAll('[data-bn-scramble]').forEach(function (el, idx) {
    if (RM) return;
    var burst = function () {
      var n = 0, iv = setInterval(function () { el.textContent = GLY[Math.floor(Math.random() * GLY.length)]; if (++n > 8) { clearInterval(iv); el.textContent = '??'; } }, 75);
    };
    setTimeout(function loop() { burst(); setTimeout(loop, 2800 + Math.random() * 2600); }, 900 + idx * 380);
  });

  /* ---------- contagem regressiva (horário de Brasília) ---------- */
  var cw = root.querySelector('[data-bn-count]');
  if (cw) {
    var marks = [
      { t: Date.parse(cw.getAttribute('data-open')), l: 'A Black November começa em' },
      { t: Date.parse(cw.getAttribute('data-bf')), l: 'A Black Friday começa em' },
      { t: Date.parse(cw.getAttribute('data-end')), l: 'A Black November termina em' }
    ].filter(function (m) { return !isNaN(m.t); });
    var lab = cw.querySelector('[data-bn-count-label]'), last = {}, els = {};
    ['d', 'h', 'm', 's'].forEach(function (u) { els[u] = cw.querySelector('[data-u="' + u + '"]'); });
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = Date.now(), m = null;
      for (var i = 0; i < marks.length; i++) if (marks[i].t > now) { m = marks[i]; break; }
      if (!m) { cw.hidden = true; return; }
      if (lab.textContent !== m.l) lab.textContent = m.l;
      var s = Math.floor((m.t - now) / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(v).forEach(function (k) {
        var txt = pad(v[k]);
        if (last[k] === txt) return;
        els[k].textContent = txt;
        if (last[k] !== undefined && !RM) { els[k].classList.remove('is-flip'); void els[k].offsetWidth; els[k].classList.add('is-flip'); }
        last[k] = txt;
      });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- botões que levam ao formulário ---------- */
  var form = root.querySelector('[data-bn-form]');
  root.querySelectorAll('a[href="#bn-form"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { var f = form.querySelector('input:not([type=hidden]),select'); if (f) f.focus({ preventScroll: true }); }, RM ? 0 : 700);
    });
  });

  /* ---------- botão fixo no celular ---------- */
  var sticky = root.querySelector('[data-bn-sticky]'), fin = root.querySelector('[data-bn-final]'), hero = root.querySelector('.bn-hero');
  if (sticky && form && hasIO) {
    var vis = { form: true, fin: false };
    var upd = function () { var past = window.scrollY > (hero ? hero.offsetHeight * 0.55 : 400); sticky.classList.toggle('is-on', past && !vis.form && !vis.fin); };
    var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.target === form) vis.form = e.isIntersecting; else vis.fin = e.isIntersecting; }); upd(); });
    io2.observe(form); if (fin) io2.observe(fin);
    window.addEventListener('scroll', upd, { passive: true });
  }

  /* ---------- UTMs guardadas na sessão ---------- */
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'], store = {};
  try { store = JSON.parse(sessionStorage.getItem('bn_utm') || '{}'); } catch (e) {}
  try {
    var qs = new URLSearchParams(location.search), changed = false;
    UTM.forEach(function (k) { var v = qs.get(k); if (v) { store[k] = v.slice(0, 250); changed = true; } });
    if (changed) sessionStorage.setItem('bn_utm', JSON.stringify(store));
  } catch (e) {}
  root.querySelectorAll('[data-utm]').forEach(function (i) { i.value = store[i.getAttribute('data-utm')] || ''; });

  /* ---------- confete de % ---------- */
  function confetti() {
    if (RM) return;
    var c = document.createElement('canvas');
    c.className = 'bn-confetti'; c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);
    var F = fit(c), ps = [];
    for (var i = 0; i < 150; i++) ps.push({ x: F.w / 2 + (Math.random() - 0.5) * 140, y: F.h * 0.4, vx: (Math.random() - 0.5) * 15, vy: -7 - Math.random() * 10, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.3, s: 10 + Math.random() * 18, pct: Math.random() < 0.5, col: Math.random() < 0.78 ? '#FED600' : '#FFFFFF' });
    var t0 = performance.now();
    (function step(t) {
      var g = F.ctx, alive = false; g.clearRect(0, 0, F.w, F.h);
      ps.forEach(function (p) {
        p.vy += 0.32; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        if (p.y < F.h + 40) alive = true;
        g.save(); g.translate(p.x, p.y); g.rotate(p.r); g.fillStyle = p.col;
        if (p.pct) { g.font = '900 ' + p.s + 'px "BN Archivo", Archivo, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText('%', 0, 0); }
        else g.fillRect(-p.s / 4, -p.s / 9, p.s / 2, p.s / 4.5);
        g.restore();
      });
      if (alive && t - t0 < 5000) raf(step); else c.remove();
    })(t0);
  }

  /* ---------- obrigado ---------- */
  var thanks = root.querySelector('[data-bn-thanks]');
  function showThanks() {
    if (!thanks) return;
    thanks.hidden = false;
    raf(function () { thanks.classList.add('is-on'); });
    confetti();
    var b = thanks.querySelector('[data-bn-close]'); if (b) setTimeout(function () { b.focus(); }, 60);
  }
  function hideThanks() { if (!thanks || thanks.hidden) return; thanks.classList.remove('is-on'); setTimeout(function () { thanks.hidden = true; }, 360); }
  if (thanks && !thanks.classList.contains('bn-thanks--page')) {
    thanks.addEventListener('click', function (e) { if (e.target === thanks || e.target.closest('[data-bn-close]')) hideThanks(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideThanks(); });
  }
  root.querySelectorAll('[data-bn-share]').forEach(function (a) { a.addEventListener('click', function () { pub('cpe:bn_share_click', {}); }); });
  if (root.querySelector('.bn-thanks--page')) {
    var flag = null;
    try { flag = sessionStorage.getItem('bn_submitted'); sessionStorage.removeItem('bn_submitted'); } catch (e) {}
    if (flag) pub('cpe:bn_lead', {});
    setTimeout(confetti, 300);
  }

  /* ---------- formulário ---------- */
  if (!form) return;
  var $ = function (s) { return form.querySelector(s); };
  var nome = $('#bn-nome'), email = $('#bn-email'), whats = $('#bn-whats'), cons = $('[data-bn-consent]');
  var chips = [].slice.call(form.querySelectorAll('.bn-chips input'));
  var btn = form.querySelector('button[type=submit]'), btnT = btn.querySelector('.bn-btn-t'), btnLabel = btnT.textContent;
  /* retorno com erro da CloudPage (?bn_erro=1) */
  try {
    if (/[?&]bn_erro=1/.test(location.search)) {
      var al = form.querySelector('[data-bn-alert]'); if (al) al.hidden = false;
      setTimeout(function () { form.scrollIntoView({ block: 'center' }); }, 300);
    }
  } catch (e) {}
  /* volta a habilitar o botão se o navegador restaurar a página pelo histórico */
  window.addEventListener('pageshow', function () { btn.disabled = false; btnT.textContent = btnLabel; });

  whats.addEventListener('input', function () {
    var d = whats.value.replace(/\D/g, '').slice(0, 11), out = '';
    if (d.length) out = '(' + d.slice(0, 2);
    if (d.length > 2) { var rest = d.slice(2), cut = rest.length > 8 ? 5 : 4; out += ') ' + rest.slice(0, cut) + (rest.length > cut ? '-' + rest.slice(cut) : ''); }
    whats.value = out;
  });

  var started = false;
  form.addEventListener('focusin', function () { if (!started) { started = true; pub('cpe:bn_form_start', {}); } });

  function mark(el, bad) {
    var w = el.closest('.bn-f'); if (w) w.classList.toggle('is-err', bad);
    if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
  }
  function clearOn(ev) { var w = ev.target.closest('.bn-f'); if (w && w.classList.contains('is-err')) { w.classList.remove('is-err'); ev.target.removeAttribute('aria-invalid'); } }
  form.addEventListener('input', clearOn); form.addEventListener('change', clearOn);

  function validate() {
    var ok = true, first = null;
    var check = function (el, good) { mark(el, !good); if (!good) { ok = false; first = first || el; } };
    var parts = nome.value.trim().split(/\s+/).filter(Boolean);
    check(nome, parts.length >= 2);
    check(email, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim()));
    check(whats, /^\d{2}9\d{8}$/.test(whats.value.replace(/\D/g, '')));
    var any = chips.some(function (c) { return c.checked; });
    mark(chips[0], !any); if (!any) { ok = false; first = first || chips[0]; }
    check(cons, cons.checked);
    return { ok: ok, first: first, parts: parts };
  }

  /* duas etapas: contato primeiro, perfil depois */
  var panels = [].slice.call(form.querySelectorAll('[data-step]'));
  var bar2 = form.querySelector('[data-bn-bar2]'), stepLabel = form.querySelector('[data-bn-steplabel]');
  function go(n, focus) {
    panels.forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-step') === n); });
    if (bar2) bar2.classList.toggle('is-on', n === 2);
    if (stepLabel) stepLabel.textContent = 'Etapa ' + n + ' de 2';
    if (focus) { var f = form.querySelector('[data-step="' + n + '"] input:not([type=hidden]), [data-step="' + n + '"] select'); if (f) f.focus({ preventScroll: true }); }
  }
  function shake() { form.classList.remove('is-shake'); void form.offsetWidth; form.classList.add('is-shake'); }
  if (panels.length) {
    go(1, false);
    var nextBtn = form.querySelector('[data-bn-next]'), prevBtn = form.querySelector('[data-bn-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var ok = true, first = null;
      [[nome, nome.value.trim().split(/\s+/).filter(Boolean).length >= 2],
       [email, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())],
       [whats, /^\d{2}9\d{8}$/.test(whats.value.replace(/\D/g, ''))]].forEach(function (c) { mark(c[0], !c[1]); if (!c[1]) { ok = false; first = first || c[0]; } });
      if (!ok) { shake(); first.focus(); return; }
      pub('cpe:bn_step2', {});
      go(2, true);
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(1, true); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-step="1"]') && e.target.tagName === 'INPUT') { e.preventDefault(); nextBtn && nextBtn.click(); }
    });
  }

  form.addEventListener('submit', function (e) {
    var v = validate();
    if (!v.ok) {
      e.preventDefault();
      shake();
      if (v.first && v.first.closest('[data-step="1"]')) go(1, false);
      if (v.first && v.first.focus) v.first.focus();
      return;
    }
    form.querySelector('[data-bn="first"]').value = v.parts[0];
    form.querySelector('[data-bn="last"]').value = v.parts.slice(1).join(' ');
    btn.disabled = true; btnT.textContent = 'Enviando…';
    pub('cpe:bn_submit', {});
    if (form.getAttribute('data-mode') === 'preview') {
      e.preventDefault();
      setTimeout(function () {
        showThanks();
        btn.disabled = false; btnT.textContent = btnLabel;
      }, 900);
      return;
    }
    try { sessionStorage.setItem('bn_submitted', '1'); } catch (err) {}
    /* segue o envio normal (POST) para a CloudPage, que grava na Data Extension e devolve para a página de obrigado */
  });
})();
